import React from 'react';
import { CardViewContentBlockProps } from './types';
import { Typography } from '@mui/material';
import CategoryCard from '../../../../common/category-card/CategoryCard';
import CategoryCardGrid from '../../../../common/category-card/CategoryCardGrid';
import { CATEGORY_CARD_ACCENTS } from '../../../../common/category-card/types';
import { useTranslation } from 'react-i18next';
import TerminationIcon from '../../../../../assets/svg/termination.svg?react';
import PolicyIcon from '../../../../../assets/svg/policy.svg?react';
import ProposalIcon from '../../../../../assets/svg/proposal.svg?react';
import ProjectMaterialsIcon from '../../../../../assets/svg/project-materials.svg?react';
import InvoicingIcon from '../../../../../assets/svg/invoicing.svg?react';
import TendersIcon from '../../../../../assets/svg/tenders.svg?react';
import { TAGS_LABELS } from '../../../../common/constants/tags-labels';
import { Helpers } from '../../../../common/helpers/helpers';
import { useAppSelector } from '../../../../common/hooks/useAppSelector';
import { selectAllCompanies } from '../../../../slices/companies/companiesSlice';

export const CustomersCategoryContent = ({ templates, setWorkflow }: CardViewContentBlockProps) => {
  const { t } = useTranslation();
  const templatesFilteredByCategory = [...templates].filter(
    (template) =>
      'dl_workflows' in template && 'is_free' in template && template.category === 'Customers'
  );
  const company = useAppSelector(selectAllCompanies)[0];
  const getTemplatesCount = (workflow: string) => {
    return templatesFilteredByCategory.filter((el) => el.dl_workflows?.includes(workflow)).length;
  };
  const getFreeTemplatesCount = (workflow: string) => {
    return templatesFilteredByCategory.filter(
      (el) => el.dl_workflows?.includes(workflow) && el.is_free
    ).length;
  };
  const getTemplatesCountByWorkflow = (workflow: string) => {
    return templatesFilteredByCategory.filter((el) => el.dl_workflows?.includes(workflow)).length;
  };
  const getIcon = (workflow: string) => {
    switch (workflow) {
      case t('tagsLabels.documentWorkflow.customer.agreement'):
        return <PolicyIcon />;
      case t('tagsLabels.documentWorkflow.customer.proposalOrQuote'):
        return <ProposalIcon />;
      case t('tagsLabels.documentWorkflow.customer.customerProjectMaterials'):
        return <ProjectMaterialsIcon />;
      case t('tagsLabels.documentWorkflow.customer.invoicing'):
        return <InvoicingIcon />;
      case t('tagsLabels.documentWorkflow.customer.tenders'):
        return <TendersIcon />;
      case t('tagsLabels.documentWorkflow.customer.termination'):
        return <TerminationIcon />;
    }
  };

  const getWorkflowNumber = (workflow: string) => {
    switch (workflow) {
      case t('tagsLabels.documentWorkflow.customer.proposalOrQuote'):
        return '1. ';
      case t('tagsLabels.documentWorkflow.customer.agreement'):
        return '2. ';
      case t('tagsLabels.documentWorkflow.customer.invoicing'):
        return '3. ';
    }
  };

  return (
    <>
      <Typography
        variant='h3'
        component='h3'
        sx={{ marginBottom: '16px', fontSize: '15px', lineHeight: '24px' }}
      >
        {t('headers.workflows')}
      </Typography>
      <CategoryCardGrid id='libraryCustomersCategoryContentGrid'>
        {TAGS_LABELS.documentWorkflow.customer.map((el) =>
          getTemplatesCountByWorkflow(t(el)) > 0 ? (
            <CategoryCard
              id={`customersCategoryContentCustomerCard_${el}`}
              key={el}
              title={Helpers.capitalizeTitle(getWorkflowNumber(t(el)) + t(el))}
              countLabel={t(
                getTemplatesCount(t(el)) === 1
                  ? 'categoryCards.templateCountSingular'
                  : 'categoryCards.templateCountPlural',
                { count: getTemplatesCount(t(el)) }
              )}
              accent={CATEGORY_CARD_ACCENTS.Customers}
              hasFreeLabel={
                getFreeTemplatesCount(t(el)) > 0 &&
                !company?.stripe_subscription &&
                !company?.stripe_product_id
              }
              onClick={() => setWorkflow(t(el))}
              icon={getIcon(t(el))}
            />
          ) : null
        )}
      </CategoryCardGrid>
    </>
  );
};
